import { FETCH_COMMENTS_SUCCESS, FETCH_COMMENTS_REQUEST, FETCH_COMMENTS_FAILURE, REFETCH_COMMENTS_DATA_SUCCESS, isCommentsPagingAction, FETCH_DEEP_LINK_REQUEST, FETCH_DEEP_LINK_SUCCESS, FETCH_DEEP_LINK_FAILURE, BULK_FETCH_COMMENTS_REQUEST, BULK_FETCH_COMMENTS_SUCCESS, BULK_FETCH_COMMENTS_FAILURE, isUnmountAllResourcesAction, } from './paging/comments-paging-actions';
import { isCommmentsCrudAction } from './top-level-comments/top-level-comments-crud-actions';
import { isCommentsAction, isCommentsBulkFetchAction, } from './comment-action-types';
import { mapValues } from 'lodash';
import { repliesCrudReducer } from './replies/replies-crud-reducer';
import { isRepliesCrudAction } from './replies/replies-crud-actions';
import { commentsCrudReducer } from './top-level-comments/top-level-comments-crud-reducer';
import { commentsReactionReducer } from './reactions/comments-reaction-reducer';
import { isCommmentsReactionAction } from './reactions/comments-reaction-actions';
import { commentsPagingReducer, commentFetchResponseToChunk, } from './paging/comments-paging-reducer';
import { isLiveUpdatesAction } from './live-updates/live-updates-actions';
import { liveUpdatesReducer } from './live-updates/live-updates-reducer';
import { isMarkCommentAction } from './mark/mark-actions';
import { commentsMarkReducer } from './mark/mark-reducer';
import { isCommmentsVoteAction } from './votes/comments-vote-actions';
import { commentsVoteReducer } from './votes/comments-vote-reducer';
import { isEffectsAction } from './effects/effects-actions';
import { effectsReducer } from './effects/effects-reducer';
import { isLifecycleAction } from './lifecycle/lifecycle-actions';
import { lifecycleReducer } from './lifecycle/lifecycle-reducer';
import { isRatingsAction } from './ratings/ratings-actions';
import { ratingsReducer } from './ratings/ratings-reducer';
import { canHaveVotes } from './top-level-comments/top-level-comment-types';
import { getVotesStateIN, mergeVoteState } from './votes/comments-vote-utils';
import { isHistoryAction } from './history/history-actions';
import { historyReducer } from './history/history-reducer';
export function commentsReducer(state = {}, action) {
    if (action.type === REFETCH_COMMENTS_DATA_SUCCESS) {
        const { commentsDataByResourceId } = action.payload;
        return updateRefetchedData(state, commentsDataByResourceId);
    }
    if (isLiveUpdatesAction(action)) {
        return liveUpdatesReducer(state, action);
    }
    if (isCommentsBulkFetchAction(action)) {
        const newState = mapBulkFetchCommentsStateToSingleCommentsActions(action, state);
        return {
            ...state,
            ...newState,
        };
    }
    if (isUnmountAllResourcesAction(action)) {
        return {};
    }
    if (!isCommentsAction(action)) {
        return state;
    }
    const resourceId = action.payload.resourceId;
    const currentResourceCommentsState = state[resourceId];
    const nextResourceCommentsState = resourceCommentsStateReducer(currentResourceCommentsState, action);
    if (currentResourceCommentsState !== nextResourceCommentsState) {
        return {
            ...state,
            [resourceId]: nextResourceCommentsState,
        };
    }
    return state;
}
const mapBulkFetchCommentsStateToSingleCommentsActions = (action, commentsState) => {
    switch (action.type) {
        case BULK_FETCH_COMMENTS_REQUEST: {
            return action.payload.reduce((acc, item) => ({
                ...acc,
                [item.resourceId]: resourceStateOnFetchRequest({
                    state: commentsState[item.resourceId],
                    requestId: item.requestId,
                    pagination: item.pagination,
                    withVotes: item.withVotes,
                    withRatings: item.withRatings,
                }),
            }), {});
        }
        case BULK_FETCH_COMMENTS_SUCCESS: {
            return action.payload.commentsByResourceId.reduce((acc, item) => ({
                ...acc,
                [item.resourceId]: resourceStateOnFetchSuccess({
                    state: commentsState[item.resourceId],
                    requestId: action.payload.requestId,
                    votes: item.votes,
                    comments: item.comments,
                    permissions: item.permissions,
                    registrationData: action.payload.response.registrationData,
                    pagination: item.pagination,
                    ratings: item.ratings,
                    currentRating: item.currentRating,
                    ctxFields: item.ctxFields,
                    totalComments: item.totalComments,
                    reactions: item.reactions,
                }),
            }), {});
        }
        case BULK_FETCH_COMMENTS_FAILURE: {
            return action.payload.reduce((acc, item) => ({
                ...acc,
                [item.resourceId]: resourceStateOnFetchFailure({
                    state: commentsState[item.resourceId],
                    requestId: item.requestId,
                    subType: 'FAILED',
                }),
            }), {});
        }
    }
};
// Reducer of single resource comments
function resourceCommentsStateReducer(state, action) {
    if (isLifecycleAction(action)) {
        return lifecycleReducer(state, action);
    }
    switch (action.type) {
        case FETCH_DEEP_LINK_REQUEST:
        case FETCH_COMMENTS_REQUEST:
            return resourceStateOnFetchRequest({
                state,
                requestId: action.payload.requestId,
                pagination: action.payload.pagination,
                withVotes: action.payload.withVotes,
                withRatings: action.payload.withRatings,
            });
        case FETCH_DEEP_LINK_SUCCESS:
        case FETCH_COMMENTS_SUCCESS: {
            return resourceStateOnFetchSuccess({
                state,
                requestId: action.payload.requestId,
                votes: action.payload.response.votes,
                comments: action.payload.response.comments,
                registrationData: action.payload.response.registrationData,
                permissions: action.payload.response.permissions,
                currentRating: action.payload.response.currentRating,
                ratings: action.payload.response.ratings,
                pagination: action.payload.pagination,
                focusCommentId: action.type === FETCH_DEEP_LINK_SUCCESS ? action.payload.commentId : undefined,
                ctxFields: action.payload.ctxFields,
                totalComments: action.payload.response.totalComments,
                reactions: action.payload.response.reactions,
            });
        }
        case FETCH_DEEP_LINK_FAILURE:
            return resourceStateOnFetchFailure({
                state,
                requestId: action.payload.requestId,
                subType: action.payload?.serverError?.status === 404 ? 'COMMENT_NOT_FOUND' : 'FAILED',
            });
        case FETCH_COMMENTS_FAILURE:
            return resourceStateOnFetchFailure({
                state,
                requestId: action.payload.requestId,
                subType: 'FAILED',
            });
        default:
    }
    if (state?.type !== 'READY') {
        return state;
    }
    // Other actions have meaning only when initial load is done
    if (isRepliesCrudAction(action)) {
        return repliesCrudReducer(state, action);
    }
    if (isCommmentsCrudAction(action)) {
        return commentsCrudReducer(state, action);
    }
    if (isCommmentsReactionAction(action)) {
        return commentsReactionReducer(state, action);
    }
    if (isMarkCommentAction(action)) {
        return commentsMarkReducer(state, action);
    }
    if (isCommentsPagingAction(action)) {
        return commentsPagingReducer(state, action);
    }
    if (isCommmentsVoteAction(action)) {
        return commentsVoteReducer(state, action);
    }
    if (isEffectsAction(action)) {
        return effectsReducer(state, action);
    }
    if (isRatingsAction(action)) {
        return ratingsReducer(state, action);
    }
    if (isHistoryAction(action)) {
        return historyReducer(state, action);
    }
    return state;
}
const resourceStateOnFetchRequest = ({ state, requestId, pagination, withVotes, withRatings, }) => {
    return {
        type: 'PENDING',
        pendingRequestId: requestId,
        configs: { pagination, withVotes, withRatings },
        lastTotals: state?.type === 'PENDING'
            ? state.lastTotals
            : state?.type === 'READY'
                ? state.totals
                : undefined,
    };
};
const resourceStateOnFetchSuccess = ({ state, requestId, votes, comments: responseComments, registrationData, pagination, focusCommentId, currentRating, ratings, permissions, ctxFields, totalComments, reactions, }) => {
    if (state?.type === 'PENDING' && state.pendingRequestId === requestId) {
        const [chunk, comments, replies] = commentFetchResponseToChunk({
            comments: responseComments,
            votes,
            reactions,
        });
        return {
            ...state,
            type: 'READY',
            componentState: 'VISIBLE',
            topLevelCommentList: {
                liveCommentsPurgatory: [],
                nextChunkState: { type: 'IDLE' },
                prevChunkState: { type: 'IDLE' },
                chunks: [chunk],
            },
            totals: totalComments,
            commentsById: comments,
            replyLists: replies,
            configs: {
                ctxFields,
                permissions: {
                    permissions,
                    registrationData,
                },
                pagination,
                withVotes: state.configs.withVotes,
                withRatings: state.configs.withRatings,
            },
            ratings: {
                total: ratings.total,
                breakdown: ratings.breakdown,
                publishedCommentCount: currentRating.publishedCommentCount,
                currentRating: {
                    type: 'IDLE',
                    value: currentRating.rating,
                },
                inputRating: currentRating.rating,
            },
            effects: {
                someoneIsTyping: 'none',
                highlight: focusCommentId
                    ? { type: 'DEEP_LINK', id: focusCommentId, timestamp: Date.now() }
                    : undefined,
            },
            historyById: {},
        };
    }
    return state;
};
const resourceStateOnFetchFailure = ({ state, requestId, subType, }) => {
    if (state?.type !== 'PENDING' || state.pendingRequestId !== requestId) {
        return state;
    }
    return {
        ...state,
        type: 'ERROR',
        failedRequestId: state.pendingRequestId,
        subType,
        error: '',
    };
};
const updateRefetchedData = (state, commentsDataByResourceId) => {
    return mapValues(state, (resourceCommentsState, resourceId) => {
        const { permissions, votes } = commentsDataByResourceId[resourceId];
        if (!resourceCommentsState || resourceCommentsState.type !== 'READY') {
            return resourceCommentsState;
        }
        return {
            ...resourceCommentsState,
            configs: {
                ...resourceCommentsState.configs,
                permissions: {
                    ...resourceCommentsState.configs.permissions,
                    permissions,
                },
            },
            commentsById: mapValues(resourceCommentsState.commentsById, (commentState) => {
                if (!('commentId' in commentState) || commentState.type !== 'COMMENT_READY') {
                    return commentState;
                }
                const updatedCommentVotes = votes.filter((v) => v.commentId === commentState.commentId);
                if (!updatedCommentVotes) {
                    return commentState;
                }
                if (canHaveVotes(commentState)) {
                    const nextVotesState = getVotesStateIN(commentState.comment, updatedCommentVotes);
                    const prevVotesState = commentState.votes;
                    return {
                        ...commentState,
                        votes: mergeVoteState(prevVotesState, nextVotesState),
                    };
                }
                return commentState;
            }),
        };
    });
};
//# sourceMappingURL=comments-reducer.js.map